/**
 * 指定数値までのランダムな数値を返します
 *
 * @param max 返却最大数値（デフォルト: 100）
 */
export function getRandomNumber(max: number = 100): number {
  if (max == null || max < 0) {
    console.error('Invalid max value. max:', max)
    return 0
  }

  return Math.floor(Math.random() * max)
}
